import { CookieSerializeOptions, parse, serialize } from 'cookie';

const defaultOptions: CookieSerializeOptions = {
  secure: true,
};

export class ThirdPartyCookieError extends Error {
  public cookieName: string;

  constructor(cookieName: string) {
    super();

    this.name = 'ThirdPartyCookieError';
    this.cookieName = cookieName;
    this.message = `Unable to set cookie: ${cookieName}`;
    this.stack = new Error().stack;

    Object.setPrototypeOf(this, ThirdPartyCookieError.prototype);
  }
}

export type CookieOptions = Pick<
  CookieSerializeOptions,
  'domain' | 'expires' | 'path' | 'httpOnly' | 'secure' | 'encode' | 'sameSite'
>;

export type RemoveCookieOptions = Pick<CookieOptions, Exclude<keyof CookieOptions, 'expires'>>;

type SetCookie = (name: string, value: string, options?: CookieOptions) => void;
export const set: SetCookie = (name, value, options) => {
  const cookie = serialize(name, value, {
    ...defaultOptions,
    ...options,
  });

  document.cookie = cookie;
  const writtenCookieValue = get(name);
  if (writtenCookieValue !== value) {
    throw new ThirdPartyCookieError(name);
  }
};

type RemoveCookie = (name: string, options?: RemoveCookieOptions) => void;
export const remove: RemoveCookie = (name, options) => {
  const cookie = serialize(name, '', {
    ...defaultOptions,
    ...options,
    expires: new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
  });

  document.cookie = cookie;
};

type GetCookie = (name: string) => string | undefined;
export const get: GetCookie = (name) => {
  const parsed = parse(document.cookie);

  return parsed[name];
};
